var api = require("!../../../../../node_modules/.pnpm/style-loader@1.3.0_webpack@5.102.1/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@5.102.1/node_modules/css-loader/dist/cjs.js!../../../../../node_modules/.pnpm/sass-loader@10.5.2_sass@1.93.3_webpack@5.102.1/node_modules/sass-loader/dist/cjs.js!./LookupView.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};